import BrandMark from './BrandMark'
import type { FooterLabels } from '@/pages/landing/types'

export default function Footer({ labels }: { labels: FooterLabels }) {
  return (
    <footer className="py-10 px-[22px] border-t-2 border-ink">
      <div className="max-w-[1080px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2 font-body font-extrabold text-ink">
          <BrandMark className="w-[18px] h-[22px]" />
          Kego <span className="text-flame">Fûté</span>
          <span className="text-ink-soft font-semibold text-sm">{labels.tagline}</span>
        </div>
        <div className="text-ink-faint text-xs font-semibold">
          © {new Date().getFullYear()} Kego Fûté. {labels.rights}
        </div>
      </div>
    </footer>
  )
}
